import { render, staticRenderFns } from "./FolderHeading.vue?vue&type=template&id=f76ffb44&"
import script from "./FolderHeading.vue?vue&type=script&lang=js&"
export * from "./FolderHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports